module.exports = __webpack_public_path__ + "static/media/foodd.24c98774.png";